document.querySelectorAll(
  '.trustpilot-reviews__viewport:not(.trustpilot-reviews__viewport--marquee) .trustpilot-reviews__track'
).forEach((track) => {
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  let isDragging = false;
  let dragMoved = false;
  let startX = 0;
  let startScrollLeft = 0;

  track.addEventListener('pointerdown', (event) => {
    if (!isDesktop() || event.pointerType !== 'mouse') return;
    isDragging = true;
    dragMoved = false;
    startX = event.clientX;
    startScrollLeft = track.scrollLeft;
    track.setPointerCapture(event.pointerId);
    track.style.cursor = 'grabbing';
    track.style.userSelect = 'none';
  });

  track.addEventListener('pointermove', (event) => {
    if (!isDragging) return;
    const delta = event.clientX - startX;
    if (Math.abs(delta) > 3) dragMoved = true;
    track.scrollLeft = startScrollLeft - delta;
  });

  const endDrag = () => {
    if (!isDragging) return;
    isDragging = false;
    track.style.cursor = '';
    track.style.userSelect = '';
  };

  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);
  track.addEventListener('pointerleave', endDrag);

  track.addEventListener(
    'click',
    (event) => {
      if (dragMoved) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  track.addEventListener(
    'wheel',
    (event) => {
      if (!isDesktop()) return;
      if (track.scrollWidth <= track.clientWidth) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      event.preventDefault();
      track.scrollLeft += event.deltaY;
    },
    { passive: false }
  );
});
